import * as jQuery from "jquery";
import * as targetEnv from "targetenv";

if (targetEnv.isBrowser) {
    // johng, 2015-12: this is needed, at minimum, for integration tests
    // to trigger the 'pliLoadedScripts' event. It is also needed to
    // expose '$' as a global window variable for debugging purposes. We
    // could have done this using browserify-shim, but that would make it
    // available as a global variable in node/non-browser contexts.
    // Consider moving this to window.dbg.$ at some point.
    (global as any).$ = jQuery;

    // milang, 2015-12: This global is needed to properly initialize
    // "velocity-animate" below in "jQuery plugin" mode
    (global as any).jQuery = jQuery;

    /* tslint:disable */
    require("velocity-animate");
    /* tslint:enable */
}

export = jQuery;



// WEBPACK FOOTER //
// /Users/johng/dev/web-pli/jquery/index.ts